/*******************************************************************************
 * Copyright (c) 2019-2021 Singularity AI, Inc. - All Rights Reserved
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 ******************************************************************************/
import pic from './login-bg.jpg';
import styled from 'styled-components';
const DivStyled = styled.div`
  background-image: url(${pic});
  background-size: cover;
`
export default function ForgotPassword({ forgotPassword, updateFormState }) {
  return (
    <DivStyled className="h-screen bg-gray-50 flex flex-col py-12 sm:px-6 lg:px-8">
      {/* logo */}
      <a className="flex items-center" href="https://singularity.ai/">
        <img
          className="h-12 w-auto mr-4"
          src="/logo512.png"
          alt="logo"
        />
        <img
          className="w-auto"
          src="/logo-text.png"
          alt="logo-text"
        />
      </a>

      <div className="mt-48 sm:mx-auto sm:w-full sm:max-w-md bg-white rounded-lg">
        <div className="bg-white py-16 px-12 shadow sm:rounded-lg sm:px-10">
          <h2 className="text-3xl font-bold leading-10 text-gray-900">Forgot your password?</h2>
          <p className='text-base font-medium leading-normal text-gray-600 py-4'>Don't fret! Just type in your email and we will send you a code to reset your password!</p>
          <div>
            <label htmlFor="username" className="block text-sm font-medium text-gray-700">
              Your email
            </label>
            <div className="mt-1">
              <input
                id="username"
                name="username"
                placeholder="name@example.com"
                autoComplete="email"
                required
                onChange={e => { e.persist(); updateFormState(e) }}
                className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-sprimary-500 focus:border-sprimary-500 sm:text-sm"
              />
            </div>
          </div>
          <div className="pt-4">
            <button
              className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-sprimary-600 hover:bg-sprimary-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-sprimary-500"
              onClick={forgotPassword}
            >
              Recover password
            </button>
          </div>
        </div>
      </div>
    </DivStyled>
  );
}
